import React, { FC } from "react";
import { Text, Image, RichText, Link } from "@sitecore-jss/sitecore-jss-react";
import LinksAccordion from "./components/LinksAccordion";
import LazySection from "../../react-only-components/LazySection";
import { FooterModel } from "./types/Footer.model";
import { FooterProps } from "./types/Footer.types";
import Navigation from "./components/Navigation";
import SocialMedia from "./components/SocialMedia";
import BackToTop from "./components/BackToTop";

import "./styles.scss";
import { LinkField } from "../../types/types";

const Footer: FC<FooterProps> = (props) => {
  const model = new FooterModel(props);

  const handleClick = () => {
    if( typeof window !== 'undefined' ) {
      window.location.href = model.logoLink?.value?.href ?? '';
    }
  };

  return (
    <>
      {props.fields && (
        <LazySection offset={0}>
          <div className="footer">
            <div className="footer-content">
              <div className="footer__columns">
                <div className="footer__columnA-wrapper">
                  <Link
                    field={model.logoLink as LinkField}
                    onClick={handleClick}
                  >
                    <Image
                      field={model.image}
                      className="footer__logo desktopImage"
                    />
                    <Image
                      field={
                        model.mobileImage ?
                        (Object.keys(model.mobileImage?.value ?? []).length > 0
                          ? model.mobileImage
                          : (model.allowFallbackForMobile ? model.image : undefined)) : undefined
                      }
                      className="footer__logo mobileImage"
                    />
                  </Link>
                  <RichText
                    className="footer__slogan"
                    field={model.slogan}
                  ></RichText>
                </div>
                {model.footerSections.map((item, i) => (
                  <LinksAccordion key={i} fields={item.fields?.footerLinks} />
                ))}
              </div>
              <BackToTop field={model.backToTopText} />
              <Navigation fields={model.navigationSection} />
              <div className="footer__social">
                <Text
                  tag="p"
                  field={model.copyrightText}
                  className="footer__copyright-text"
                />
                <div className="footer__social footer__social--dad">
                  <Text
                    tag="h2"
                    field={model?.socialMediaLinks?.Title}
                    className="footer-accordion__link footer-accordion__link--social"
                  />
                  <div className="footer__social__links">
                    <SocialMedia fields={model.socialMediaLinks} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LazySection>
      )}
    </>
  );
};

export default Footer;
